import { inject, injectable } from 'inversify';
import { EGlobalDIKeys } from 'core/di/keys';
import type { IChannel } from '../Channel/types';
import type { IWebSocketService } from '../WebSocketService';
import PrivateChannel from '../Channel/PrivateChannel';
import Channel from '../Channel/Channel';
import { IChannels } from './types';

@injectable()
class Channels implements IChannels {
  private _channels: Record<string, IChannel> = {};

  constructor(
    @inject(EGlobalDIKeys.WebSocketService)
    private readonly _webSocketService: IWebSocketService,
  ) {}

  /**
   * Создает канал с кэшированием
   */
  private _getOrCreateChannel(
    key: string,
    channelName: string,
    isPrivate = false,
  ): IChannel {
    if (!this._channels[key]) {
      if (isPrivate) {
        this._channels[key] = new PrivateChannel(
          { name: channelName },
          this._webSocketService,
        );
      } else {
        this._channels[key] = new Channel({ name: channelName });
      }
    }

    return this._channels[key];
  }

  filesChannel(): IChannel {
    return this._getOrCreateChannel(`files`, `files`, true);
  }

  tenderRpcChannel(): IChannel {
    return this._getOrCreateChannel(`tender`, `tender`);
  }

  /**
   * Тендерный канал для основных обновлений
   */
  tenderChannel(tenderGuid: string): IChannel {
    return this._getOrCreateChannel(`tender_${tenderGuid}`, `tender:${tenderGuid}`, true);
  }

  /**
   * Персональный канал для всех файловых операций
   */
  personalChannel(): IChannel {
    return this._getOrCreateChannel('personal', 'personal', true);
  }

  /**
   * Канал для проверки контрагентов
   */
  companyChannel(companyGuid: string): IChannel {
    return this._getOrCreateChannel(
      `company:${companyGuid}`,
      `company:${companyGuid}`,
      true,
    );
  }

  companyRpcChannel(): IChannel {
    return this._getOrCreateChannel('company', 'company', false);
  }

  lotChannel(logGuid: string): IChannel {
    return this._getOrCreateChannel(`lot:${logGuid}`, `lot:${logGuid}`, true);
  }

  lotRpcChannel(): IChannel {
    return this._getOrCreateChannel('lot', 'lot', false);
  }
}

export default Channels;
